import { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';

import bg from './assets/bg.svg';

type Props = {
  children: ReactNode;
};
const Hexagon = styled(Horizontal)`
  background-image: url(${bg});
  background-size: contain;
  background-repeat: no-repeat;
  width: var(--triple-unit);
  height: var(--triple-unit);
  justify-content: center;
  align-items: center;
`;

export const BreakdownIcon = ({ children }: Props) => {
  return (
    <Hexagon>
      <LabelS color="var(--c-nd-600)" bold>
        {children}
      </LabelS>
    </Hexagon>
  );
};
